import {
  Box,
  Checkbox as MaterialCheckbox,
  CheckboxProps as MaterialCheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperTextProps,
} from '@mui/material';
import React from 'react';

import { FormHelperText } from '../FormHelperText/FormHelperText';

export interface CheckboxProps extends MaterialCheckboxProps {
  helperText?: FormHelperTextProps['children'];
  label?: FormControlLabelProps['label'];
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  error?: boolean;
}

const STYLES = { whiteSpace: 'break-spaces', '& .MuiStack-root': { display: 'block' } };

/**
 * The Checkbox
 *
 */
export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  labelPlacement,
  helperText,
  error,
  required,
  ...props
}: CheckboxProps) => {
  return (
    <Box>
      <FormControlLabel
        disableTypography={true}
        labelPlacement={labelPlacement}
        control={<MaterialCheckbox color={error ? 'error' : props.color} {...props} />}
        label={label}
        sx={STYLES}
        required={required}
        color={error ? 'error' : props.color}
      />
      {!!helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  );
};
